import { type FC, useState } from "react"
import { useSearchParams } from "react-router"

import Button from "~/components/Button"
import Layout, { PageHeader, PageTitle } from "~/components/Layout"
import LoadingError from "~/components/LoadingError"
import PartialLoadingPage from "~/components/PartialLoadingPage"
import useProductPublishedAlert from "~/hooks/useProductPublishedAlert"
import { query } from "~/utilities/trpc"

import CreateEventModal from "./CreateEventModal"
import Events from "./Events"

const EventsPage: FC = () => {
	const publishedAlert = useProductPublishedAlert("event")
	const [searchParams] = useSearchParams()

	const { data: events, error, refetch } = query.event.list.useQuery(undefined, { refetchOnWindowFocus: false })

	const [isCreateEventModalOpen, setCreateEventModalOpen] = useState(searchParams.get("create") === "true")

	return (
		<Layout>
			<CreateEventModal
				isOpen={isCreateEventModalOpen}
				onClose={() => setCreateEventModalOpen(false)}
				onCreated={async createdId => {
					await refetch()
					await publishedAlert.show({ itemId: createdId })
					setCreateEventModalOpen(false)
				}}
			/>
			<PageHeader>
				<PageTitle>Events</PageTitle>
				<Button variant="primary" onClick={() => setCreateEventModalOpen(true)}>
					Create event
				</Button>
			</PageHeader>
			{error && events === undefined ? (
				<LoadingError subject="events" error={error} onRetry={refetch} />
			) : events === undefined ? (
				<PartialLoadingPage />
			) : (
				<Events events={events} onReload={refetch} />
			)}
		</Layout>
	)
}

export default EventsPage
